import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaMusic } from 'react-icons/fa';
import '../styles/NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <FaMusic className="not-found-icon" />
        <h1>404</h1>
        <h2>Page non trouvée</h2>
        <p>Désolé, la page que vous recherchez n'existe pas.</p>
        <div className="not-found-actions">
          <Link to="/" className="btn-home">
            <FaHome /> Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
